import { useQueryState } from "nuqs";
import StudentChangeImage from "./components/StudentChangeImage";
import StudentChangePassword from "./components/StudentChangePassword";
import StudentQrCode from "./components/StudentQrCode";
import StudentResults from "./components/StudentResults";

const Profile = () => {
  const [section, setSection] = useQueryState("results", {
    defaultValue: "results",
  });

  return (
    <section className="h-auto width flex flex-col items-center justify-center gap-10">
      <StudentQrCode />

      <div className="flex gap-4 w-full justify-center">
        <button
          onClick={() => {
            setSection("changeImage");
          }}
          className={`min-w-[200px] rounded-xl border-2 border-secondary p-4 font-semibold  transition-all duration-300 hover:bg-light hover:text-secondary   active:scale-90 ${
            section === "changeImage" && "bg-secondary text-light"
          }`}
        >
          تغير الصوره الشخصية
        </button>
        <button
          onClick={() => {
            setSection("changePassword");
          }}
          className={`min-w-[200px] rounded-xl border-2 border-secondary p-4 font-semibold  transition-all duration-300 hover:bg-light hover:text-secondary   active:scale-90 ${
            section === "changePassword" && "bg-secondary text-light"
          }`}
        >
          تغير كلمة المرور
        </button>

        <button
          onClick={() => {
            setSection("results");
          }}
          className={`min-w-[200px] rounded-xl border-2 border-secondary p-4 font-semibold  transition-all duration-300 hover:bg-light hover:text-secondary   active:scale-90 ${
            section === "results" && "bg-secondary text-light"
          }`}
        >
          النتائج
        </button>
      </div>

      {section === "changeImage" && <StudentChangeImage />}
      {section === "changePassword" && <StudentChangePassword />}
      {section === "results" && <StudentResults />}
    </section>
  );
};

export default Profile;
